import { RequestDataModel } from '@ktvs8/gocoo-engine-front-end';

export function findSupplierByTicketKey(requestModel: RequestDataModel) {
  const ticketKey = requestModel.requestData['TicketKey'];
  return MSupplierTestData.find((x) => x.TicketKey === ticketKey);
}

/**
 * @param requestModel 発注先の検索処理
 * @returns
 */
export function filterMSupplierTestData(requestModel: RequestDataModel) {
  return MSupplierTestData;
}

/**
 * 発注先のテストデータ
 */
export const MSupplierTestData = [
  {
    TicketType: 'MSupplier',
    TicketKey: 'test@co.jp#EmailAddress1',
    SupplierName: '吉本興業株式会社',
    Person: '山本',
    EmailAddress: 'test@co.jp',
    Memo: 'テストです',
    IsFreelance: true,
    Active: true,
  },
  {
    TicketType: 'MSupplier',
    TicketKey: 'in@co.jp#EmailAddress3',
    SupplierName: 'インダストリアル・イリュージョニスト',
    Person: 'ペガサス・J・クロフォード',
    EmailAddress: 'test@co.jp',
    Memo: 'テストです',
    IsFreelance: false,
    Active: true,
  },
  {
    TicketType: 'MSupplier',
    TicketKey: 'kaiba@co.jp#EmailAddress3',
    SupplierName: '海馬コーポレーション',
    Person: '海馬瀬戸',
    EmailAddress: 'kaiba@co.jp',
    Memo: 'テストです',
    IsFreelance: 'true',
    Active: true,
  },
  {
    TicketType: 'MSupplier',
    TicketKey: 'tanaka@co.jp#EmailAddress2',
    SupplierName: '株式会社Tanaka',
    Person: '田中',
    EmailAddress: 'tanaka@co.jp',
    Memo: '田中だよ',
    IsFreelance: 'false',
    Active: true,
  },
];
